export const FieldSpecialType = {
	None: 0,
	Date: 1,
	GPS: 2,
	Attachment: 3,
} as const;

export type FieldSpecialType = (typeof FieldSpecialType)[keyof typeof FieldSpecialType];
